import { createScale } from '../internal';
import type { VitalParameterBounds } from '../types';

export const spo2Scale2AirBounds: VitalParameterBounds = [
  {
    lower: 0,
    upper: 83,
    score: {
      type: 'low',
      value: 3,
    },
  },
  {
    lower: 84,
    upper: 85,
    score: {
      type: 'low',
      value: 2,
    },
  },
  {
    lower: 86,
    upper: 87,
    score: {
      type: 'low',
      value: 1,
    },
  },
  {
    lower: 88,
    upper: 92,
    score: {
      type: 'normal',
      value: 0,
    },
  },
  {
    lower: 93,
    upper: 100,
    score: {
      type: 'normal',
      value: 0,
    },
  },
];

/**
 * SpO2 (%) Scale 2/Air `integer`
 */
export const spo2Scale2Air = createScale(spo2Scale2AirBounds, 0);
